var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.33397 7.33195L5.90475 12.7483C6.15951 12.9964 6.50834 13.067 6.81986 12.9337C7.13137 12.8003 7.35824 12.4832 7.415 12.1017C7.47176 11.7203 7.3498 11.3325 7.09504 11.0844L2.3803 6.5L7.09504 1.91561C7.3498 1.66754 7.47176 1.27974 7.415 0.898293C7.35824 0.516849 7.13137 0.199712 6.81986 0.0663438C6.50834 -0.0670241 6.15951 0.00363894 5.90475 0.251715L0.33397 5.66805C0.122434 5.87387 0.00014019 6.17864 0.00014019 6.5C0.00014019 6.82136 0.122434 7.12613 0.33397 7.33195Z",
    fill: "#03030A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.c80d7a864cc4f4cb91be5f28c3424368.svg";
export { ForwardRef as ReactComponent };